import { Icon, Popover, Button } from '@mc/react-core';
import * as React from 'react';
import { MultiSelectSearch } from './MultiSelectSearch';

type Val = string[] | number[];
type Item = { label: string; id: string | number };
type Props = React.PropsWithChildren<{
  value: Val;
  onChange: (newVal: Val) => void;
  options: Item[];
}>;
export const AddFilter: React.FC<Props> = ({
  value,
  onChange,
  options,
  children = (
    <Button>
      <Icon icon="plus" /> Přidat
    </Button>
  ),
}) => (
  <Popover
    minimal
    target={children as React.ReactElement}
    position="bottom"
    content={
      <MultiSelectSearch
        value={value as any}
        onChange={onChange}
        items={options}
      />
    }
  />
);
